import { render } from "./TextMessage.vue?vue&type=template&id=63be7566&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"

import "./TextMessage.vue?vue&type=style&index=0&id=63be7566&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63be7566"

export default script